module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "electonicReport"
  }, [_c('h2', [_vm._v("浙医二院解放路二区")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.elcRep.modality) + "检查申请单")]), _vm._v(" "), _c('div', {
    staticClass: "repTop"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("病案号")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.mediId))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("申请单号")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.hisRequestId))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('span', [_vm._v("急诊分级")]), _vm._v(":"), _c('p', [_vm._v("自定义")]), _vm._v(" "), _c('div', {
    staticClass: "checked"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.emergent),
      callback: function($$v) {
        _vm.emergent = $$v
      },
      expression: "emergent"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("急")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "repMiddle"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("姓名")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientName))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("性别")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientSex))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("年龄")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientAge))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("出生日期")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientBirth || _vm.elcRep.birthday))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("联系电话")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientMobile))])]), _vm._v(" "), _c('li'), _vm._v(" "), (_vm.elcRep.height !== undefined) ? _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("身高")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.height) + "cm")])]) : _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("身高")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.height))])]), _vm._v(" "), (_vm.elcRep.weight !== undefined) ? _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("体重")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.weight) + "kg")])]) : _c('li', {
    staticStyle: {
      "width": "11%"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("体重")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.weight))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("科别")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.requestDept || _vm.elcRep.requestDeptName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("床号")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.bedNo))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "54%"
    }
  }, [_c('span', [_vm._v("陪送方式")]), _vm._v(":\n        "), _c('div', {
    staticClass: "checked"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.ways),
      callback: function($$v) {
        _vm.ways = $$v
      },
      expression: "ways"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "0",
      "disabled": ""
    }
  }, [_vm._v("医生")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("护士")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("护工")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("家属")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("不陪")])], 1)], 1)]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('span', [_vm._v("送检方式")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.inspectionMode))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("收费信息")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.chargeInfo))])])])]), _vm._v(" "), _c('div', {
    staticClass: "repContent"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("主诉")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientComplaint))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("体征")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.patientSign))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("病史")]), _vm._v(":"), _c('p', [_vm._v("\n        " + _vm._s(_vm.elcRep.patientHistory))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("临床诊断")]), _vm._v(":"), _c('p', [_vm._v("\n        " + _vm._s(_vm.elcRep.clinicDiagnosis || _vm.elcRep.medicalResult))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("医生嘱托")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.drEntrustment))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("项目检查")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.examineItems || _vm.elcRep.examBodyName))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block",
      "width": "33%"
    }
  }, [_c('span', [_vm._v("工作单位")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.workUnit))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block",
      "width": "33%"
    }
  }, [_c('span', [_vm._v("住址")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.address))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block",
      "width": "32%"
    }
  }, [_c('span', [_vm._v("职业")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.vocation))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("申请医生")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.requestDr || _vm.elcRep.requestDoctorName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("医生电话")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.requestDrTel))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("申请时间")]), _vm._v(":"), _c('p', [_vm._v(_vm._s(_vm.elcRep.billApplyDate))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7fc89366","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/report/electronicReport.vue
// module id = 585
// module chunks = 1 2 3 4 5 6 7 8